module.exports = __webpack_public_path__ + "static/img/-L6gw6lad-OOG6GrFXMG.e8606b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/-L6gw6lad-OOG6GrFXMG.jpg
// module id = uPHQ
// module chunks = 1